export class Serializer {

    serialize(obj) {
        try {
            return JSON.stringify(obj);
        } catch(error) {
            return null;
        }
    }

    deserialize(json) {
        try {
            return JSON.parse(json);
        } catch(error) {
            return null;
        }
    }

    clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    
}